/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { invoke } from "./invoke.js";
/**
 * Methods for understanding desktop performance.
 *
 * @remarks
 * This package exposes a number of methods that allow you to access performance information such as CPU usage.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
/**
 * Indicates the creation time of the application. The time is represented as number of milliseconds since epoch.
 *
 * @returns number.
 * @public
 */
export async function getCreationTime() {
    return invoke({
        namespace: "process",
        method: "getCreationTime",
        args: [],
    });
}
/**
 * Returns an object with V8 heap statistics. Note that all statistics are reported in Kilobytes.
 *
 * @returns HeapStatistics object.
 * @public
 */
export async function getHeapStatistics() {
    return invoke({
        namespace: "process",
        method: "getHeapStatistics",
        args: [],
    });
}
/**
 * Returns an object with Blink memory information. It can be useful for debugging rendering / DOM related memory issues. Note that all values are reported in Kilobytes.
 *
 * @returns BlinkMemoryInfo object.
 * @public
 */
export async function getBlinkMemoryInfo() {
    return invoke({
        namespace: "process",
        method: "getBlinkMemoryInfo",
        args: [],
    });
}
/**
 * Returns an object giving memory usage statistics about the current process. Note that all statistics are reported in Kilobytes.
 *
 * @returns ProcessMemoryInfo object.
 * @public
 */
export async function getProcessMemoryInfo() {
    return invoke({
        namespace: "process",
        method: "getProcessMemoryInfo",
        args: [],
    });
}
/**
 * Returns an object giving memory usage statistics about the entire system. Note that all statistics are reported in Kilobytes.
 *
 * @returns SystemMemoryInfo object.
 * @public
 */
export async function getSystemMemoryInfo() {
    return invoke({
        namespace: "process",
        method: "getSystemMemoryInfo",
        args: [],
    });
}
/**
 * Retrieves CPU usage.
 *
 * @returns CPUUsage object.
 * @public
 */
export async function getCPUUsage() {
    return invoke({
        namespace: "process",
        method: "getCPUUsage",
        args: [],
    });
}
